module.exports = __webpack_public_path__ + "static/img/D100-AWL5.478b238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/D100-AWL5.png
// module id = lPuN
// module chunks = 0